import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../helpers/hooks';

const FormanDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="forman-dashboard">
      {/* Welcome Section */}
      <div className="forman-welcome">
        <h1>Merhaba, {user?.firstName}!</h1>
        <p>Bugün ne yapmak istersin?</p>
      </div>

      {/* Module Cards */}
      <div className="forman-modules">
        {/* QR Okutma */}
        <button
          className="forman-module-card forman-module-qr"
          onClick={() => navigate('/forman/qr-scan')}
        >
          <div className="module-icon">
            <i className="ri-qr-scan-2-line"></i>
          </div>
          <div className="module-content">
            <h2>QR Okut</h2>
            <p>İrsaliye QR kodunu tara</p>
          </div>
          <div className="module-arrow">
            <i className="ri-arrow-right-line"></i>
          </div>
        </button>

        {/* Günlük Kayıt */}
        <button
          className="forman-module-card forman-module-daily"
          onClick={() => navigate('/forman/daily-record')}
        >
          <div className="module-icon">
            <i className="ri-calendar-check-line"></i>
          </div>
          <div className="module-content">
            <h2>Günlük Kayıt</h2>
            <p>Personel ve araç puantajı</p>
          </div>
          <div className="module-arrow">
            <i className="ri-arrow-right-line"></i>
          </div>
        </button>
      </div>

      {/* Date Display */}
      <div className="forman-date">
        <i className="ri-calendar-line me-2"></i>
        {new Date().toLocaleDateString('tr-TR', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </div>
    </div>
  );
};

export default FormanDashboard;
